import {createDraftSafeSelector} from '@reduxjs/toolkit';
import {TAppRootState} from 'core/redux/types';
import {yandexMapModuleName} from 'modules/yandex-map/slice';
import {IYandexMapState} from 'modules/yandex-map/types';

const select = (state: TAppRootState): IYandexMapState => state[yandexMapModuleName];

export const selectYandexMapIsLoading = createDraftSafeSelector([select], (state) => state.isLoading);
export const selectYandexMapIsLoadSuccess = createDraftSafeSelector([select], (state) => state.isLoadSuccess);
